// extracted by mini-css-extract-plugin
export default {"wrapper":"TenantInfo_wrapper__Fb0Ps","tenantInfoItem":"TenantInfo_tenantInfoItem__f+eN-","loader":"TenantInfo_loader__3RwG7"};